<template>
  <div id="container">
    <div v-if="loading" class="loading">Loading...</div>

    <div v-if="error" class="error">{{ error }}</div>

    <div v-if="post" class="content">
      <youtube v-if="isCourse" :video-id="post.youtube_link" resize fitParent />
      <img
        v-else-if="post.image != ''"
        id="img"
        v-bind:src="baseUrl + 'image_upload/' + post.image"
      />
      <div id="content_container">
        <h2 id="title">{{ post.title }}</h2>
        <p id="date">{{ post.date }}</p>
        <div v-if="post.file" style="display: flex; align-items: center">
          <div style="margin-right: 20px">文件下載:</div>
          <a v-bind:href="baseUrl + 'pdf/' + post.file" target="_blank">
            <img src="../assets/pdf.gif" alt="" width="50" />
          </a>
        </div>
        <p id="content" v-html="post.content"></p>
      </div>
      <div id="share_button">
        <v-dialog v-model="dialog" width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              rounded
              small
              width="90px"
              height="30px"
              light
              style="align-items: center"
              v-bind="attrs"
              v-on="on"
              >分享</v-btn
            >
          </template>

          <v-card>
            <v-card-title class="headline grey lighten-2">Share</v-card-title>
            <v-card-text>
              <p>
                <ShareNetwork
                  network="facebook"
                  v-bind:url="baseUrl + this.$route.params.type + '/' + post.id"
                  v-bind:title="post.title"
                  v-bind:description="
                    post.title +
                    '\n' +
                    baseUrl +
                    this.$route.params.type +
                    '/' +
                    post.id
                  "
                >
                  <i class="fab fah fa-lg fa-facebook"></i>
                  <span>Facebook</span>
                </ShareNetwork>
              </p>
              <br />
              <p>
                <ShareNetwork
                  network="email"
                  v-bind:url="''"
                  v-bind:title="post.title"
                  v-bind:description="
                    post.title +
                    '\n' +
                    baseUrl +
                    this.$route.params.type +
                    '/' +
                    post.id
                  "
                >
                  <!-- 
                  v-bind:url="baseUrl+this.$route.params.type+'/'+post.id" -->
                  <i class="far fah fa-lg fa-envelope"></i>
                  <span>Email</span>
                </ShareNetwork>
              </p>
              <br />
              <p>
                <ShareNetwork
                  network="whatsapp"
                  v-bind:url="''"
                  v-bind:title="''"
                  v-bind:description="
                    post.title +
                    '\n' +
                    baseUrl +
                    this.$route.params.type +
                    '/' +
                    post.id
                  "
                >
                  <!-- 
                  v-bind:description="post.content" -->
                  <i class="fab fah fa-lg fa-whatsapp"></i>
                  <span>Whatsapp</span>
                </ShareNetwork>
              </p>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>
<style scoped>
#container {
  padding: 15px 70px 15px 70px;
}

.content #img {
  width: 100%;
}

#content_container {
  font-family: "mehk-m";
  margin: 0px 20% 0px 20%;
  border-bottom: rgb(234, 234, 234) 1px solid;
}

.content #title {
  padding-top: 10px;
  font-size: 30px;
}
.content #date {
  font-size: 15px;
}
.content #content {
  padding-top: 10px;
  font-size: 18px;
  padding-bottom: 70px;
}
#share_button {
  margin: 10px 20% 0px 20%;
  text-align: right;
}
.share-network-facebook {
  background-color: rgb(22, 120, 242);
  color: white;
  padding: 5px;
}
.share-network-facebook a {
  background-color: rgb(19, 95, 194);
}
.share-network-facebook span {
  padding-left: 10px;
}

.share-network-email {
  background-color: #333333;
  color: white;
  padding: 5px;
}

.share-network-email span {
  padding-left: 10px;
}
.share-network-whatsapp {
  background-color: #25d366;
  color: white;
  padding: 5px;
}

.share-network-whatsapp span {
  padding-left: 10px;
}
iframe {
  width: 100%;
  /* max-width: 650px; Also helpful. Optional. */
}
@media only screen and (max-width: 1060px) {
  #content_container {
    margin: 0;
  }
}
</style>

<script>
export default {
  data() {
    return {
      loading: false,
      post: null,
      error: null,
      dialog: false,
      isCourse: false,
      baseUrl: "",
    };
  },
  created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.fetchData();
  },
  mounted() {
    this.getBaseUri();
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: "fetchData",
  },
  methods: {
    getBaseUri() {
      this.axios
        .get("/api/api.php?p=data/baseUrl")
        .then((response) => {
          this.baseUrl = response.data.sdata["url"];
          // console.log(this.baseUrl);
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },
    fetchData() {
      this.error = this.post = null;
      this.loading = true;

      // console.log(this.$route.params.id);
      // console.log(this.$route.params.type);

      // replace getPost with your data fetching util / API wrapper
      var functionName = "";
      if (this.$route.params.type == "event") {
        functionName = "eventPost";
      } else if (this.$route.params.type == "article") {
        functionName = "articlePost";
      } else if (this.$route.params.type == "publish") {
        functionName = "publishPost";
      } else if (this.$route.params.type == "course") {
        functionName = "coursePost";
        this.isCourse = true;
      }

      const urlParams = new URLSearchParams();
      urlParams.append("id", this.$route.params.id);
      this.axios({
        method: "post",
        url: "/api/api.php?p=data/" + functionName,
        data: urlParams,
      })
        .then((response) => {
          this.loading = false;
          this.post = response.data.sdata["data"];

          const testDate = new Date(this.post.date);
          const month =
            testDate.getMonth() < 9
              ? "0" + (testDate.getMonth() + 1)
              : testDate.getMonth() + 1;
          const day =
            testDate.getDate() < 9
              ? "0" + testDate.getDate()
              : testDate.getDate();
          const date = testDate.getFullYear() + "/" + month + "/" + day;
          this.post.date = date;
          // console.log(this.post.image);
          // if(response.data.sdata["data"].file.length > 0){

          // }

          if (this.post.youtube_link != null) {
            //is youtube video
            // console.log(this.post.youtube_link.indexOf("watch?v="));
            // console.log(this.post.youtube_link.indexOf("&"));
            // console.log(this.$youtube.getIdFromUrl(this.post.youtube_link));
            this.post.youtube_link = this.$youtube.getIdFromUrl(
              this.post.youtube_link
            );
            // this.post.youtube_link = this.post.youtube_link.substring(
            //   this.post.youtube_link.indexOf("watch?v=") + 8,
            //   this.post.youtube_link.indexOf("&") != -1
            //     ? this.post.youtube_link.indexOf("&")
            //     : this.post.youtube_link.length
            // );

            // console.log(this.post.youtube_link);
          }
        })
        .catch(function (error) {
          // 请求失败处理
          this.error = error.toString();
          console.log(error);
        });
    },
  },
};
</script>